<template>
  <div
    tabindex="-1"
    role="dialog"
    class="modal-side-drawer-filters fade fixed-end op"
  >
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Advanced Search</h2>
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true"><i class="far fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" v-if="__initialized">
          <div class="data-filters">
            <div class="row">
              <div class="col-12 col-lg-5">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input type="text" class="form-control" :value="filters.search" @input="updateSearch"/>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <label>Client</label>

                <multiselect
                  :options="clients"
                  :show-labels="false"
                  :allow-empty="true"
                  placeholder
                  v-model="clientSelected"
                  label="company"
                />
              </div>

              <div class="col-6 col-lg-2">
                <label>Sort</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-sort-amount-down"></i>
                  </span>

                  <multiselect
                    :options="sortByOptions"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder
                    v-model="sortBy"
                    label="name"
                  />
                </div>
              </div>

              <div class="col-6 col-lg-2">
                <label>Show</label>

                <multiselect
                  :options="archivedOptions"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder
                  v-model="archivedSelected"
                  label="name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null,
        client: null,
        sort: 'newest',
        archived: null
      },
      sortByOptions: [
        { name: 'Newest First', key: 'newest' },
        { name: 'A-Z', key: 'asc' },
        { name: 'Z-A', key: 'desc' }
      ],
      archivedOptions: [
        { name: 'Active', key: null },
        { name: 'Include Archived', key: '1' }
      ]
    }
  },

  computed: {
    ...mapState('clientsList', ['clients']),

    sortBy: {
      get () {
        return this.sortByOptions.find(({ key }) => key === this.filters.sort)
      },

      set (value) {
        this.filters.sort = value.key
      }
    },

    archivedSelected: {
      get () {
        return this.archivedOptions.find(({ key }) => key == this.filters.archived)
      },

      set (value) {
        this.filters.archived = value.key
      }
    },

    clientSelected: {
      get () {
        return this.clients.find(({ id }) => id === parseInt(this.filters.client))
      },

      set (value) {
        this.filters.client = value ? value.id : null
      }
    }
  },

  methods: {
    ...mapActions('clientsList', ['getClients']),

    updateSearch: debounce(function (event) {
      this.filters.search = event.target.value
    }, 750)
  },

  created () {
    this.getClients()
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
